import { fetchGetNewbuildingLayoutsMobile } from '../shared/repositories/newbuilding-card/v2/get-newbuilding-layouts-mobile';
import { assertBadHttpStatus } from './assert';
export async function fetchLayouts(_ref) {
  let {
    params,
    httpApi,
    logger
  } = _ref;
  try {
    const response = await fetchGetNewbuildingLayoutsMobile({
      httpApi,
      parameters: params,
      config: {
        requestConfig: {
          headers: [['Content-Type', 'application/json']]
        }
      }
    });
    assertBadHttpStatus(response);
    return response.response.layoutsInfo || null;
  } catch (error) {
    logger.error(error, {
      domain: 'src/services/fetchLayouts'
    });
    return null;
  }
}